<template>
  <div >
    <div class="tips" v-if="form_id == 0">重要提醒：所有信息一经提交无法修改，提交前请仔细核对信息！请勿随意申报</div>
    <van-form @submit="onSubmit">
      <van-field
        v-if="form_id != 0"
        v-model="form_id"
        :disabled="disabled"
        label="申请id"
        placeholder=""
      />

      <van-field
        v-model="form.name"
        :disabled="disabled"
        name="name"
        label="姓名(必填)"
        placeholder="需和银行账户的户名一致"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        v-model="form.id_number"
        :disabled="disabled"
        name="id_number"
        label="身份证号(必填)"
        placeholder="身份证号"
        :rules="[{ pattern: /^[1-8][0-7]\d{4}(?:19|20)\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{3}[\dX]$/,required: true, message: '请填写正确的证件号' }]"
      />
      <van-field
        v-model="form.telephone"
        :disabled="disabled"
        name="telephone"
        label="手机号(必填)"
        type="digit"
        placeholder="手机号"
        :rules="[{ pattern: /^1\d{10}$/,required: true, message: '请填写正确手机号' }]"
      />
      <van-field
        v-if="fid>3 && fid< 6"
        readonly
        clickable
        :disabled="disabled"
        name="subdistrict"
        :value="form.subdistrict"
        label="选择街道(必填)"
        placeholder="点击选择"
        @click="showSubdistrictPicker = true"
        :rules="[{ required: true, message: '选择街道' }]"
      />
      <van-popup v-model="showSubdistrictPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="subdistrictList[fid]"
          @confirm="subdistrictConfirm"
          @cancel="showSubdistrictPicker = false"
        />
      </van-popup>
      <van-field
        v-model="form.address"
        :disabled="disabled"
        name="address"
        label="房屋详细地址(必填)"
        placeholder="需和房产证中一致"
        :rules="[{ required: true, message: '请填写房产证中地址' }]"
      />
      <van-field
        v-model="form.car_price"
        :disabled="disabled"
        name="invoice_amount"
        label="申报发票总金额/元(必填)与申请表合计总价一致"
        type="number"
        placeholder="请仔细核对发票统计金额"
        :rules="[{ required: true}]"
      />
      <van-field
        v-model="form.bank_name"
        :disabled="disabled"
        name="bank_name"
        label="补贴收款银行开户行(必填)建议使用一类卡"
        placeholder="补贴收款银行开户行"
        :rules="[{ required: true, message: '请填写补贴收款银行开户行' }]"
      />
      <van-field
        v-model="form.bank_card_no"
        name="bank_card_no"
        :disabled="disabled"
        label="补贴收款银行账户号(必填)"
        placeholder="补贴收款银行账户号"
        :rules="[{ required: true, message: '请填写补贴收款银行账户号' }]"
      />
      <van-field name="photo_id_front" label="身份证照片正面(必填)" :disabled="disabled" :rules="[{ required: true, message: '请填上传图片' }]">
        <template #input>
          <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_id_front" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="1" ></van-uploader>
        </template>
      </van-field>
      <van-field name="photo_id_reverse" label="身份证照片背面(必填)" :disabled="disabled" :rules="[{ required: true, message: '请填上传图片' }]">
        <template #input>
          <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_id_reverse" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="1" ></van-uploader>
        </template>
      </van-field>
      <van-field name="photo_notification" label="装修备案通知书(必填)" :disabled="disabled" :rules="[{ required: true, message: '请填上传图片' }]">
        <template #input>
          <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_notification" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="10" ></van-uploader>
        </template>
      </van-field>
      <van-field name="photo_estate_license" label="房产证明照片(必填)" :disabled="disabled" :rules="[{ required: true, message: '请填上传图片' }]">
        <template #input>
          <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_estate_license" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="10" ></van-uploader>
        </template>
      </van-field>
      <div>非整包，请上传合同图片<br/>整包，请上传PDF文件</div>
      <van-tabs color="#1989fa" v-model="renovationType">
        <van-tab  title="非整包装修">
          <van-field name="photo_contract" label="非整包装修合同照片(必填)" :disabled="disabled" :rules="[{ message: '请填上传图片' }]">
            <template #input>
              <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_contract" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="10" ></van-uploader>
            </template>
          </van-field>
          <div style="height: 1rem;"></div>
        </van-tab>
        <van-tab title="整包装修">
          <van-field name="pdf_contract" label="整包装修合同PDF(必填)" :disabled="disabled" :rules="[{ message: '请填上传pdf文件不超过15M' }]">
            <template #input>
              <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="15 * 1024 *1024" v-model="form.pdf_contract" :before-read="beforeReadPdf" :after-read="afterReadPdf" accept="application/pdf" @oversize="onOversize(15)" :max-count="1" ></van-uploader>
            </template>
          </van-field>
          <div style="height: 1rem;"></div>
        </van-tab>
        
      </van-tabs>
      
      <van-field name="photo_invoice" label="发票照片(必填)" :disabled="disabled" :rules="[{ required: true, message: '上传图片' }]">
        <template #input>
          <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_invoice" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="10" ></van-uploader>
        </template>
      </van-field>
      <van-field name="photo_pay_record" label="支付凭证照片(必填)" :disabled="disabled" :rules="[{ required: true, message: '上传图片' }]">
        <template #input>
          <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_pay_record" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="10" ></van-uploader>
        </template>
      </van-field>
      <van-field name="photo_commitment" label="购置补贴申请表(必填)" :disabled="disabled" :rules="[{ required: true, message: '上传图片' }]">
        <template #input>
          <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_commitment" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="10" ></van-uploader>
        </template>
      </van-field>
      <van-tabs color="#1989fa" v-model="renovationStatus">
        <van-tab  title="还在装修">
          <van-field name="photo_renovation_before" label="材料进场照片(选填)" :disabled="disabled" :rules="[{ message: '上传图片' }]">
            <template #input>
              <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_renovation_before" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="10" ></van-uploader>
            </template>
          </van-field>
          <van-field name="photo_renovation_current" label="施工中照片(必填)" :disabled="disabled" :rules="[{ required: true, message: '上传图片' }]">
            <template #input>
              <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_renovation_current" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="10" ></van-uploader>
            </template>
          </van-field>
          <div style="height: 1rem;"></div>
        </van-tab>
        <van-tab title="已装修完成">
          <van-field name="photo_renovation_before" label="材料进场照片(选填)" :disabled="disabled" :rules="[{ message: '上传图片' }]">
            <template #input>
              <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_renovation_before" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="10" ></van-uploader>
            </template>
          </van-field>
          <van-field name="photo_renovation_current" label="施工前或施工中照片(必填)" :disabled="disabled" :rules="[{ required: true, message: '上传图片' }]">
            <template #input>
              <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_renovation_current" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="10" ></van-uploader>
            </template>
          </van-field>
          <van-field name="photo_renovation_after" label="装修完工照片(必填)" :disabled="disabled" :rules="[{ message: '上传图片' }]">
            <template #input>
              <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_renovation_after" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="10" ></van-uploader>
            </template>
          </van-field>
          <div style="height: 1rem;"></div>
        </van-tab>
      </van-tabs>
      <van-field name="photo_nameplate" label="房屋竣工铭牌照片(选填)" :disabled="disabled" :rules="[{ message: '上传图片' }]">
        <template #input>
          <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_nameplate" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="10" ></van-uploader>
        </template>
      </van-field>
      
      <div style="margin: 16px;padding-bottom: 2rem;" v-if="form_id == 0">
        <van-button round :disabled="disabled" block type="info" native-type="submit">{{ submitting ? '正在提交...': (disabled ? submitBtnText : '提交') }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>

import axios from 'axios'
import Compressor from 'compressorjs'
import { mc,util } from '../../assets/common2.js'
import { ImagePreview } from 'vant'
// import Vconsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new Vconsole()
export default {
  name: 'HouseForm',
  props: {
  },
  data () {
    return {
      photo_id_front: [],
      subdistrictList: {
        4:['塔山街道','府山街道','北海街道','城南街道','稽山街道','迪荡街道','灵芝街道','东湖街道','皋埠街道','鉴湖街道','东浦街道','陶堰街道','富盛镇'],
        5:['斗门街道','沥海街道','马山街道','孙端街道']
      },
      form:{
        name:'',
        telephone: '',
        subdistrict: '',
        address: '',
        id_number: '',
        photo_id_front: [],
        photo_id_reverse: [],
        bank_name: '',
        bank_card_no: '',
        invoice_amount: '',
        photo_notification: [],
        photo_estate_license: [],
        photo_contract: [],
        photo_invoice: [],
        photo_pay_record: [],
        photo_renovation_before: [],
        photo_renovation_after: [],
        photo_commitment: [],
        photo_renovation_current: [],
        photo_nameplate: [],
        pdf_contract: [],
      },
      renovationType: 0,
      renovationStatus: 0,
      submitting: false,
      disabled: false,
      disabled2: false,
      currentDate: new Date(),
      // minDate: new Date(2024, 1, 1),
      // maxDate: new Date(2024, 2, 20),
      showPicker: false,
      uploading: {
        photo_id_front: false,
        photo_id_reverse: false,
        photo_notification: false,
        photo_estate_license: false,
        photo_contract: false,
        photo_invoice: false,
        photo_pay_record: false,
        photo_renovation_before: false,
        photo_renovation_after: false,
        photo_commitment: false,
        photo_renovation_current: false,
        photo_nameplate: false,
        pdf_contract: false
      },
      photo_old_for_new: [],
      showSubdistrictPicker: false,
      submitBtnText: '已提交'
    }
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  computed: {
    minDate () {
      return this.$store.state.fid == 1 ? new Date(2024, 1, 1) : new Date(2024, 3, 30)
    },
    maxDate () {
      return this.$store.state.fid == 1 ? new Date(2024, 2, 20) : new Date(2024, 4, 3)
    }
  },
  created: function () {
    this.form_id = this.$route.params.form_id
    this.fid = this.$route.params.fid
    if (this.$route.params.form_id > 0) {
      this.disabled = true
      // this.getDetail()
    }
    // this.active = this.$store.state.prevActive
  },
  mounted: function () {
    // console.log(vConsole);
  },
  methods: {
    onConfirm(date) {
      this.form.buy_date = date.toLocaleString().split(' ')[0]
      this.showPicker = false
    },
    priceValidate (val) {
      return val >= 50000
    },
    subdistrictConfirm(value) {
      this.form.subdistrict = value
      this.showSubdistrictPicker = false
    },
    formatter(type, val) {
      if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    upload (key) {
      this.uploading[key] = true
      let n = key == 'photo_old_for_new' ? 5 : 1
      mc.photoSelect(n,(data) => {
        if (data.status == 'complete') {
          let imgs = this.form[key] == '' ? [] : this.form[key].split(',')
          this.form[key] = imgs.concat(data.imgs.map(e => {
            return e.url.replace('http:','')
          })).join(',')
          // console.log(data.imgs);
          this.uploading[key] = false
        } else {
          this.uploading[key] = false
        }
      })
    },
    beforeReadImage (file) {
      var result = []
      if (file instanceof Array) {
        for (var f of file) {
          if (!/image.*/.test(f.type)) {
            this.$toast.fail('请上传图片');
            return false;
          }
          result.push(new Promise((resolve) => {
            new Compressor(f, {
              quality: 0.7,
              success: resolve,
              error(err) {
                console.log(err.message);
              },
            })
          }))
        }
      } else {
        result = new Promise((resolve) => {
          new Compressor(file, {
            quality: 0.7,
            success: resolve,
            error(err) {
              console.log(err.message);
            },
          })
        })
      }
      return result
    },
    beforeReadPdf (file) {
      var result = []
      if (file instanceof Array) {
        for (var f of file) {
          if (!/application\/pdf/.test(f.type)) {
            this.$toast.fail('请上传pdf');
            return false;
          }
        }
      } else {
        if (!/application\/pdf/.test(file.type)) {
            this.$toast.fail('请上传pdf');
            return false;
          }
      }
      return result
    },
    afterReadImage (file) {
      if (file instanceof Array) {
        for (var f of file) {
          this.uploadHandle(f, 'img')
        }
      } else {
        this.uploadHandle(file, 'img')
      }
    },
    afterReadPdf(file) {
      this.uploadHandle(file, 'pdf')
    },
    uploadHandle(file,type) {
      file.status = 'uploading'
      file.message = '上传中...'
      var data = new FormData()
      data.append('file', file.file)
      util.Arequest((data2) => {
        data.append('token',data2.token)
        axios.post(`/formupload/form/upload/${type}?userid=${data2.userid}&fid=${this.$store.state.fid}`,data).then(res => {
            if (res.data.msg == 'ok') {
              file.url = res.data.url
              file.status = 'done'
              file.message = ''
            } else {
              file.status = 'failed'
              file.message = '上传失败'
            } 
          }).catch(() => {
            file.status = 'failed'
            file.message = '上传失败'
          })
      })
    },

    preview(img) {
      ImagePreview([img])
    },

    submitComfirm(values) {
      this.$dialog.confirm({
        title: '确认提交',
      }).then(() => {
        this.onSubmit(values)
      })
    },
    onSubmit(values) {

      // if (values.pdf_contract && values.photo_contract) {
      //   this.$toast('装修合同不能为空')
      //   return
      // }
      if (this.renovationType == 0 && this.form.photo_contract.length == 0) {
        this.$toast('非整包装修需上传合同图片')
        return
      }
      if (this.renovationType == 1 && this.form.pdf_contract.length == 0) {
        this.$toast('整包修完需上传合同PDF')
        return
      }
      if (this.form.photo_contract.length > 0 && this.form.pdf_contract.length > 0) {
        this.$toast('不能同时上传合同照片和PDF')
        return
      }
      if (this.renovationStatus == 1 && this.form.photo_renovation_after.length == 0) {
        this.$toast('传装修完则完工照片不能为空')
        return
      }
      
      values.photo_id_front = values.photo_id_front[0]['url']
      values.photo_id_reverse = values.photo_id_reverse[0]['url']
      values.photo_invoice && (values.photo_invoice = values.photo_invoice.map(e => e.url).join(','))
      values.photo_notification && (values.photo_notification = values.photo_notification.map(e => e.url).join(','))
      values.photo_estate_license && (values.photo_estate_license = values.photo_estate_license.map(e => e.url).join(','))
      values.photo_contract && (values.photo_contract = values.photo_contract.map(e => e.url).join(','))
      values.photo_pay_record && (values.photo_pay_record = values.photo_pay_record.map(e => e.url).join(','))
      values.photo_renovation_before && (values.photo_renovation_before = values.photo_renovation_before.map(e => e.url).join(','))
      values.photo_renovation_after && (values.photo_renovation_after = values.photo_renovation_after.map(e => e.url).join(','))
      values.photo_commitment && (values.photo_commitment = values.photo_commitment.map(e => e.url).join(','))
      values.photo_renovation_current && (values.photo_renovation_current = values.photo_renovation_current.map(e => e.url).join(','))
      values.photo_nameplate && (values.photo_nameplate = values.photo_nameplate.map(e => e.url).join(','))
      values.pdf_contract && (values.pdf_contract = values.pdf_contract.map(e => e.url).join(','))
      if (this.submitting) {
        return
      }
      util.Arequest((data) => {
        this.disabled = true
        this.submitting = true
        values.token = data.token
        axios.post(`/encrypt3/form/house/submit?userid=${data.userid}&fid=${this.$store.state.fid}`,values).then(res => {
            if (res.data.msg == 'ok') {
              this.$store.commit('setNeedRefresh',true)
              this.$toast('提交成功')
              this.submitBtnText = '提交成功'
            } else if (res.data.msg == 'not admin') {
              this.$toast('无权限')
              this.submitBtnText = '无权限'
            } else if (res.data.msg == 'exists') {
              this.$toast('用户已有申请\n无法再次提交')
              this.submitBtnText = '已申请过，无法再次提交'
            } else if (res.data.msg == 'no start') {
              this.disabled = false
              this.$toast('申请还未开始')
            } else if (res.data.msg == 'end') {
              this.$toast('申请已经结束')
              this.submitBtnText = '申请已经结束'
            } else if (res.data.msg == 'unavailable') {
              this.$toast('无权限')
              this.submitBtnText = '无权限'
            } else if (res.data.msg == 'empty subdistrict') {
              this.disabled = false
              this.$toast('街道未选择')
            } else if (res.data.msg == 'empty contract') {
              this.disabled = false
              this.$toast('合同附件未上传')
            } else {
              this.disabled = false
              this.$toast('网络繁忙\n请稍后重试')
            }
            this.submitting = false
          }).catch(() => {
            this.submitting = false
            this.disabled = false
            this.$toast('网络繁忙\n请稍后重试')
          })
      })
    },
    getDetail() {
      util.Arequest((data) => {
        axios.post(`/encrypt3/form/detail?form_id=${this.form_id}&userid=${data.userid}&fid=${this.$store.state.fid}`,{token:data.token}).then(res => {
            if (res.data.msg == 'ok') {
              res.data.form.type = ''+res.data.form.type
              // this.form = res.data.form
              let form = res.data.form
              this.form = {
                name: form.name,
                telephone: form.telephone,
                type: form.type,
                id_number: form.id_number,
                car_price: form.car_price,
                buy_date: form.buy_date,
                bank_name: form.bank_name,
                bank_card_no: form.bank_card_no,
                photo_id_front: form.photo_id_front.split(',').map(e => {
                  return {url:e}
                }),
                photo_id_reverse: form.photo_id_reverse.split(',').map(e => {
                  return {url:e}
                }),
                photo_invoice: form.photo_invoice.split(',').map(e => {
                  return {url:e}
                }),
                photo_driving_license: form.photo_driving_license ? form.photo_driving_license.split(',').map(e => {
                  return {url:e}
                }) : [],
                photo_purchase_tax: form.photo_purchase_tax ? form.photo_purchase_tax.split(',').map(e => {
                  return {url:e}
                }) : [],
                photo_old_for_new: form.photo_old_for_new ? form.photo_old_for_new.split(',').map(e => {
                  return {url:e}
                }) : [],
                photo_commitment: form.photo_commitment ? form.photo_commitment.split(',').map(e => {
                  return {url:e}
                }) : [],
                old_for_new: form.old_for_new,
              }
              this.loading = false;
            } else if (res.data.msg == 'not admin') {
              this.$toast('无权限')
            } else if (res.data.msg == 'not exists') {
              this.$toast('没有该申请')
            } else if (res.data.msg == 'error merchant') {
              this.$toast('非法请求')
            } else {
              this.$toast('网络繁忙\n稍后重试')
            } 
          }).catch(() => {
            this.$toast('网络繁忙\n稍后重试')
          })
      })
    },
    
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .main {
  margin-top: 56.3vw;
} */
.tips {
  font-size: 1rem;
  color: red;
  padding: 0 1rem;
  text-align: left;
  line-height: 2rem;
}
.upload-bar {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
  height: 4.5rem;
}
.upload-icon {
  position: relative;
  width: 4.5rem;
  height: 4.5rem;
}
.upload-delete {
  position: absolute;
    top: 0;
    right: 0;
    width: 14px;
    height: 14px;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 0 0 0 12px;
}
.upload-tips {
  margin-left: 2rem;
  width: 6rem;
  font-size: 0.8rem;
  color: rgb(255, 76, 76);
}
.upload-list {
  display: flex;
  flex-wrap: wrap;
}
.upload-list .upload-item {
  margin-right: 0.2rem;
  margin-top: 0.2rem;
}
</style>
